import { Injectable } from '@angular/core';
import { BaseApiService } from '../../../core/services/base-api.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResourceEnum } from '../../../core/enums/api-resource-enum';
import { ApiActionEnum } from '../../../core/enums/api-action-enum';
import { UpsertCustomerDto } from '../dto/upsert-customer.dto';
import { ResponseCustomerDto } from '../dto/response-customer.dto';

@Injectable({
  providedIn: 'root',
})
export class CustomerService extends BaseApiService {
  constructor(private http: HttpClient) {
    super();
  }

  index(): Observable<ResponseCustomerDto[]> {
    return this.http.get<ResponseCustomerDto[]>(
      `${this.baseUrl}/${ApiResourceEnum.CUSTOMERS}/${ApiActionEnum.INDEX}`,
      {
        headers: this.httpHeaders,
      },
    );
  }

  getCustomers(): Observable<ResponseCustomerDto[]> {
    return this.http.get<ResponseCustomerDto[]>(
      `${this.baseUrl}/${ApiResourceEnum.CUSTOMERS}`,
      {
        headers: this.httpHeaders,
      },
    );
  }

  getCustomerById(id: string): Observable<ResponseCustomerDto> {
    return this.http.get<ResponseCustomerDto>(
      `${this.baseUrl}/${ApiResourceEnum.CUSTOMERS}/${id}`,
      {
        headers: this.httpHeaders,
      },
    );
  }

  getLogo(id: string, fileKey: string): Observable<string> {
    return this.http.get(
      `${this.baseUrl}/${ApiResourceEnum.CUSTOMERS}/${id}/file-url/${fileKey}`,
      this.textOptions,
    );
  }

  createCustomer(customer: UpsertCustomerDto): Observable<ResponseCustomerDto> {
    const formData = this.toFormData(customer);
    return this.http.post<ResponseCustomerDto>(
      `${this.baseUrl}/${ApiResourceEnum.CUSTOMERS}`,
      formData,
    );
  }

  updateCustomer(customer: UpsertCustomerDto): Observable<ResponseCustomerDto> {
    const formData = this.toFormData(customer);
    return this.http.patch<ResponseCustomerDto>(
      `${this.baseUrl}/${ApiResourceEnum.CUSTOMERS}/${customer.id}`,
      formData,
    );
  }

  private toFormData(customer: UpsertCustomerDto): FormData {
    const formData = new FormData();
    formData.append('businessName', customer.businessName);
    formData.append('address', customer.address);
    formData.append('numberOfStores', customer.numberOfStores.toString());
    formData.append('buyerType', customer.buyerType);
    
    if (customer.email) {
      formData.append('email', customer.email);
    }
    if (customer.vatNumber) {
      formData.append('vatNumber', customer.vatNumber);
    }
    if (customer.phone) {
      formData.append('phone', customer.phone);
    }
    if (customer.website) {
      formData.append('website', customer.website);
    }
    if (customer.logo) {
      formData.append('logo', customer.logo, customer.logo.name);
    }
    
    return formData;
  }
}
